var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#2B2B2B",
    strokeOpacity: 0.94,
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    fillOpacity: 0.8,
    d: "M20 30.667l-1.147-1.146c-1.573-1.574-1.56-4.134.027-5.68L20 22.747c-.52-.053-.907-.08-1.333-.08C15.107 22.667 8 24.454 8 28.001v2.666h12zm-1.333-10.666C21.613 20 24 17.614 24 14.667c0-2.946-2.387-5.333-5.333-5.333-2.947 0-5.334 2.387-5.334 5.333 0 2.947 2.387 5.334 5.334 5.334zM25.574 30.374c-.52.52-1.373.52-1.893 0l-2.76-2.786c-.507-.52-.507-1.347 0-1.854l.013-.013c.52-.52 1.36-.52 1.867 0l1.827 1.827 5.906-5.947c.52-.52 1.36-.52 1.88 0l.014.013c.506.52.506 1.347 0 1.854l-6.854 6.906z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonTickIcon);
export default __webpack_public_path__ + "static/media/person-tick-icon.91a3444a.svg";
export { ForwardRef as ReactComponent };